import { css } from '@emotion/react';
import { legacyOnly, newDesignOnly, type Env0Theme } from 'constants/themes.constants';
import styled from 'types/theme.types';

interface Props {
  gap?: number;
}

type StackArgs = Props & { theme: Env0Theme };

/**
 * Not consolidated onto antd Space, which B12's scope line asks for: the legacy `!important` beats a
 * margin this same ticket is changing, and almost every call site is a stack OF cards. Swapping the DOM
 * under 13 importers while those margins are in motion is a behaviour change wearing a restyle's name.
 * Revisit once the card margins have settled - APO-484 removes the branch either way.
 *
 * Both branches read `gap`, unlike the card's `itemGap`, which has never read its own value.
 */
const legacyGap = (props: StackArgs) =>
  legacyOnly(css`
    & > *:not(:last-child) {
      margin-bottom: ${props.gap ?? 25}px !important;
    }
  `)(props);

const newDesignGap = (props: StackArgs) =>
  newDesignOnly(
    theme => css`
      display: flex;
      flex-direction: column;
      gap: ${props.gap !== undefined ? `${props.gap}px` : theme.spacing.xxl};
    `
  )(props);

const Stack = styled.div<Props>`
  ${legacyGap}
  ${newDesignGap}
`;

export default Stack;
